import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type CreateWorksiteInput, createWorksite } from "@/adapters/api";

export function useCreateCanteiro() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: CreateWorksiteInput) => createWorksite(input),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["canteiros"] });
		},
	});
}
